/* eslint-disable eqeqeq */
import {Col, Row} from 'react-bootstrap'
import {RowItem} from './RowItem/RowItem'
import * as RowItems from './RowItem'

interface Props {
  showBeforeAfter: boolean
}

export const CorporationSector = (props: Props) => {
  const {showBeforeAfter} = props

  return (
    <Row>
      <Col md={showBeforeAfter ? 12 : 6}>
        {showBeforeAfter ? <RowItem showBeforeAfter={showBeforeAfter} isInfo /> : null}

        <RowItems.ID showBeforeAfter={showBeforeAfter} />
        <RowItems.SalesOrg showBeforeAfter={showBeforeAfter} />
        <RowItems.IncotermOne showBeforeAfter={showBeforeAfter} />
        <RowItems.Province showBeforeAfter={showBeforeAfter} />
        <RowItems.ProductType showBeforeAfter={showBeforeAfter} />
        <RowItems.RequestQuantum showBeforeAfter={showBeforeAfter} />
        <RowItems.FixedQuantum showBeforeAfter={showBeforeAfter} />
        <RowItems.ShippingTolerance showBeforeAfter={showBeforeAfter} />
        <RowItems.PaymentOne showBeforeAfter={showBeforeAfter} />
        <RowItems.ProductSpec showBeforeAfter={showBeforeAfter} />
        <RowItems.SegmentName showBeforeAfter={showBeforeAfter} />
      </Col>

      <Col md={showBeforeAfter ? 12 : 6}>
        <RowItems.EndCustomer showBeforeAfter={showBeforeAfter} />
        <RowItems.Sector showBeforeAfter={showBeforeAfter} />
        <RowItems.IncotermTwo showBeforeAfter={showBeforeAfter} />
        <RowItems.City showBeforeAfter={showBeforeAfter} />
        <RowItems.ProductName showBeforeAfter={showBeforeAfter} />
        <RowItems.RequestPrice showBeforeAfter={showBeforeAfter} />
        <RowItems.FixedPrice showBeforeAfter={showBeforeAfter} />

        {/* <Row>
          <Col md={6}>
            <RowItems.IncludePPN showBeforeAfter={showBeforeAfter} />
          </Col>
          <Col md={6}>
            <RowItems.FormulatedPrice showBeforeAfter={showBeforeAfter} />
          </Col>
        </Row> */}

        <RowItems.PaymentTwo showBeforeAfter={showBeforeAfter} />
        <RowItems.Notes showBeforeAfter={showBeforeAfter} />

        <RowItems.AmandementNotes showBeforeAfter={showBeforeAfter} />
        <RowItems.ExtensionDate showBeforeAfter={showBeforeAfter} />
      </Col>
    </Row>
  )
}
